import { listResponseSchema } from '@/common/api/schemas.ts';
import { z } from 'zod';

export const posListResponseSchema = listResponseSchema(
  z.object({
    id: z.number(),
    name: z.string(),
    country: z.string(),
    street: z.string(),
    streetNumber: z.string(),
    city: z.string(),
    zip: z.string(),
  })
);

export type PosListResponse = z.infer<typeof posListResponseSchema>;
